import styled from "styled-components";
import { COLORS_LIGHT } from "../custom/Values";
import { CustomParagraph } from "../custom/CustomText";
import { faSquarePollHorizontal } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Publications = ({ publications }) => {
  return (
    <PublicationListContainer>
      {publications.map((publication, idx) => (
        <PublicationListItem paper={publication} />
      ))}
    </PublicationListContainer>
  );
};


const PublicationListItem = ({ paper }) => {
  return (
    <PublicationItemContainer>
      <TitleContainer>
        <span>{paper.year} | </span>
        <Links target="_blank" href={paper.link}>
          {paper.title}
        </Links>
      </TitleContainer>
      <AuthorsContainer>
        {paper.authors.map((author, idx) => (
          <>
            <span
              style={{
                fontSize: `${
                  author === "Biniyam Tiruye" ? "16px" : ""
                }`,
                fontWeight: `${author === "Biniyam Tiruye" ? "bold" : ""}`,
              }}
              >
              {author}
            </span>
            {idx !== paper.authors.length - 1 ? ", " : ""}
          </>
        ))}
      </AuthorsContainer>
      <ConferenceContainer>
        <Links target="_blank" href={paper.conferenceLink}>
          {paper.conference}
        </Links>
      </ConferenceContainer>
      <DescriptionContainer>{paper.description}</DescriptionContainer>

          </PublicationItemContainer>
        );
      };
      const PublicationListContainer = styled.div`
        // border: 1px solid green;
        width: 100%;
      `;
      const Links = styled.a`
      border: none;
        text-decoration: none;
        outline: none;
        color: ${COLORS_LIGHT.ACCENT};
        
        &:focus {
          outline: none;
        }
        
        &:active {
          outline: none;
          border: none;
        }
      ` 
      const PublicationItemContainer = styled.div`
        // border: 1px solid ${COLORS_LIGHT.LIGHT_GRAY};
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: start;
        font-family: Montserrat;
        margin: 15px 0px;
        padding: 10px;
        border-radius: 5px;
      `;
      const TitleContainer = styled.div`
        // border: 1px solid black;
        font-weight: bold;
        font-size: 1.1em;
        margin-bottom: 4px;
        color: #222;
        text-align: left;
      `;
const ConferenceContainer = styled.div`
  // border: 1px solid black;
  font-size: 1em;
  margin-bottom: 4px;
  color: #555;
  text-align: left;
`;
const DescriptionContainer = styled.div`
  // border: 1px solid black;
  margin: 8px 0;
  font-size: 1em;
  color: #444;
  line-height: 1.5;
  text-align: left;
`;
const PosterContainer = styled.div`
  // border: 1px solid black;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const BottomContainer = styled.div`
  // border: 1px solid black;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
`;
const AuthorsContainer = styled.div`
  // border: 1px solid black;
  // display: flex;
  // flex-wrap: wrap;
  margin: 8px 0;
  font-size: 0.95em;
  color: #333;
  text-align: left;
`;
